export type AppScreen = 'home' | 'library' | 'ingredients' | 'recipes' | 'dishes' | 'menus' | 'imports' | 'scaling' | 'exports' | 'members' | 'roles' | 'audit' | 'trash' | 'media-recycle' | 'workspace-settings' | 'account' | 'more' | 'invite';

export type AppSubview = 'translation';

export interface AppRoute {
  screen: AppScreen;
  entityId?: string;
  versionId?: string;
  view?: AppSubview;
}

export function parseAppRoute(pathname: string): AppRoute {
  const parts = pathname.split('/').filter(Boolean).map(decodeURIComponent);
  if (parts[0] === 'invite' && parts[1]) return { screen: 'invite', entityId: parts[1] };
  if (parts[0] === 'library') return { screen: 'library' };
  if (parts[0] === 'recipes') {
    const route: AppRoute = { screen: 'recipes', entityId: parts[1], versionId: parts[2] === 'versions' ? parts[3] : undefined };
    if (parts[4] === 'translation') route.view = 'translation';
    return route;
  }
  if (parts[0] === 'dishes') {
    const route: AppRoute = { screen: 'dishes', entityId: parts[1], versionId: parts[2] === 'versions' ? parts[3] : undefined };
    if (parts[4] === 'translation') route.view = 'translation';
    return route;
  }
  if (parts[0] === 'menus') {
    const route: AppRoute = { screen: 'menus', entityId: parts[1], versionId: parts[2] === 'versions' ? parts[3] : undefined };
    if (parts[4] === 'translation') route.view = 'translation';
    return route;
  }
  if (parts[0] === 'ingredients') return { screen: 'ingredients', entityId: parts[1] };
  if (parts[0] === 'imports') return parts[1] ? { screen: 'imports', entityId: parts[1] } : { screen: 'imports' };
  if (parts[0] === 'scaling') return { screen: 'scaling' };
  if (parts[0] === 'exports') return { screen: 'exports' };
  if (parts[0] === 'members') return { screen: 'members' };
  if (parts[0] === 'roles') return { screen: 'roles' };
  if (parts[0] === 'audit') return { screen: 'audit' };
  if (parts[0] === 'trash') return { screen: 'trash' };
  if (parts[0] === 'media-recycle') return { screen: 'media-recycle' };
  if (parts[0] === 'workspace-settings') return { screen: 'workspace-settings' };
  if (parts[0] === 'account') return { screen: 'account' };
  if (parts[0] === 'more') return { screen: 'more' };
  return { screen: 'home' };
}

export function pathForRoute(route: AppRoute): string {
  if (route.screen === 'home') return '/';
  if (route.screen === 'invite') return route.entityId ? `/invite/${encodeURIComponent(route.entityId)}` : '/';
  if (['library', 'imports', 'scaling', 'exports', 'members', 'roles', 'audit', 'trash', 'media-recycle', 'workspace-settings', 'account', 'more'].includes(route.screen)) {
    const base = `/${route.screen}`;
    return route.screen === 'imports' && route.entityId ? `${base}/${encodeURIComponent(route.entityId)}` : base;
  }
  const base = `/${route.screen}`;
  if (!route.entityId) return base;
  const entity = `${base}/${encodeURIComponent(route.entityId)}`;
  if (!route.versionId) return entity;
  const version = `${entity}/versions/${encodeURIComponent(route.versionId)}`;
  return route.view === 'translation' ? `${version}/translation` : version;
}